/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_Email_LabelInputs */



/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Canvas_Sign_In_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_email_label = /** @type {((inputs?: Canvas_Sign_In_Email_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_Email_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail-Adresse")
	return /** @type {LocalizedString} */ ("Email address")
});